let chart_options = {
    responsive: {
        rules: [
            {
                condition: {
                    maxWidth: 380
                },
                chartOptions: {
                }
            }
        ]
    },
  chart: {
      type: 'bar',
      zoomType: 'xy',
      borderColor: '#FFFFFF'
  },
  lang:{
    drillUpText: 'Back to states'
  },
  title: {
      margin: 25,
      text: 'Loading...',
      style: {
        fontSize: '16px',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: '600'
      }
  },
  subtitle: {
      text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
  },
  credits: {
    enabled: false
  },
  xAxis: {
      type: 'category',
      //categories: null,
      title: {
          text: 'x-axis title'
      },
      labels: {
        style: {
            fontSize: '9px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: '600',
            color: '#999999'
        }
      }
  },
  yAxis: {
      gridLineWidth: 0,
      minorGridLineWidth: 0,
        plotLines:[],
      title: {
        text: 'y-axis title',
        style: {
            fontSize: '11px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 'normal',
            color: '#888888'
        }
      },
      labels: {
        style: {
            fontSize: '10px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 'normal',
            color: '#888888'
        }
      }
  },
  legend: {
      enabled: true,
      borderColor: 'black',
    //   borderRadius: 10,
      borderWidth: 3,
      title: {
        text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
        style: {
            fontSize: '12px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: '600',
            color: '#666666'
        }
      }
  },
  plotOptions: {
      series: {
        events: {
            // legendItemClick: function (e) {
            //     this.visible = !this.visible;
            //     var visibility = this.visible ? 'visible' : 'hidden';
            //     // if (!confirm('The series is currently ' +
            //     //              visibility + '. Do you want to change that?')) {
            //     //     return true;
            //     // }
            // }
        },
          borderWidth: 0,
          point:{
          },
          cursor: 'pointer',
          dataLabels: {
              enabled: true,
              format: '{point.y:.1f}',
              style: {
                fontSize: '8px',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 'normal',
                color: '#555555'
              }
          },
        // states: {
        //     hover: {
        //         enabled: true,
        //         lineWidth: 4
        //     }
        // },
          zones: []
      }
  },
  tooltip: {
      // backgroundColor: '#FCFFC5',
      // borderColor: 'black',
      // borderRadius: 10,
      // borderWidth: 3,
      // crosshairs: [true, true],
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>'
  },
  // navigation: {
  //     menuItemStyle: {
  //         fontSize: '10px'
  //     }
  // },
  series:[],
  drilldown:{
    activeAxisLabelStyle:{
      color:'black',
      textDecoration:'none',
      fontWeight: 'normal'
    },
    activeDataLabelStyle:{
      color:'black',
      textDecoration:'none',
      fontWeight: 'normal'
    },
    series:[
      {
        name:"Anambra",
        id:"Anambra",
        "data": [
                   [
                       "v65.0",
                       0.1
                   ],
                   [
                       "v64.0",
                       1.3
                   ],
                   [
                       "v63.0",
                       53.02
                   ],
                   [
                       "v62.0",
                       1.4
                   ],
                   [
                       "v61.0",
                       0.88
                   ],
                   [
                       "v60.0",
                       0.56
                   ],
                   [
                       "v59.0",
                       0.45
                   ],
                   [
                       "v58.0",
                       0.49
                   ],
                   [
                       "v57.0",
                       0.32
                   ],
                   [
                       "v56.0",
                       0.29
                   ],
                   [
                       "v55.0",
                       0.79
                   ],
                   [
                       "v54.0",
                       0.18
                   ],
                   [
                       "v51.0",
                       0.13
                   ],
                   [
                       "v49.0",
                       2.16
                   ],
                   [
                       "v48.0",
                       0.13
                   ],
                   [
                       "v47.0",
                       0.11
                   ],
                   [
                       "v43.0",
                       0.17
                   ],
                   [
                       "v29.0",
                       0.26
                   ]
               ]
      }
    ]
  }
};

var chart_options2 = {
    responsive: {
        rules: [
            {
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    chart: {
                        height: 400
                    }
                }
            }
        ]
    },
  chart: {
      type: 'line',
      zoomType: 'xy',
      events: {
          load: ''
      }
  },
  colors: ["#2f7ed8", "orange", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
  title: {
      text: 'Loading...'
  },
  subtitle: {
      text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
  },
  credits: {
    enabled: false
  },
  xAxis: {
      type: 'category',
      categories: null,
      title: {
          text: 'x-axis title'
      },
      tickInterval: 1
  },
  yAxis: {
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      title: {
          text: 'y-axis title'
      },
      // minRange: 100,
      //softMax: 100,
      // pointStart: 100
      floor: 0,
      min: 0
  },
  legend: {
      enabled: true,
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3,
      layout: 'vertical',
      align: 'right',
      floating: true,
      title: {
        // text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
        // style: {
        //   fontWeight: 'normal'
        // }
      },
      itemStyle: {
        fontWeight: 'normal',
        fontSize: '13px'
      }
  },
  plotOptions: {
      series: {
        connectNulls:true,
        borderWidth: 0,
        dataLabels: {
            enabled: false,
            format: '{point.y:.1f}%'
        },
        cursor: 'pointer',
        dashStyle: "Solid",
        point: {

        },
        marker: {
            lineWidth: 1,
            radius: 3,
            symbol: "circle"
        },
        states: {
            hover: {
                enabled: true,
                lineWidth: 4,
                // lineWidthPlus: 5
            }
        }
          // linkedTo: ':previous',
          // pointWidth: 2
        //   pointInterval: 2
          // zones: []
      }
  },

  tooltip: {
      // backgroundColor: '#FCFFC5',
      // borderColor: 'black',
      // borderRadius: 10,
      // borderWidth: 3,
      // crosshairs: [true, true],
      // crosshairs: false,
      // shared: false,
      // followPointer: true,
      // positioner: function () {
      //     return { x: 80, y: 50 };
      // },
      useHTML:true,
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      // pointFormat: '<span style="color:{point.color}">{point.key}</span>: <b>{point.y:.2f}</b> of total<br/>'
    },

  series: [],
//   drilldown: {
//       series: [{
//           name: 'Opera',
//           id: 'Opera',
//           data: [
//             //  value
//             // [
//             //     'v12.x',
//             //     0.34
//             // ],
//           ]
//       }]
//   }
};

let chart_options3 = {
    chart: {
        type: null,
        // zoomType: 'xy'
    },
    title: {
        text: 'Loading...'
    },
    subtitle: {
        text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
    },
    credits: {
      enabled: false
    },
    xAxis: {
        type: 'category',
        categories: null,
        title: {
            text: 'x-axis title'
        }
    },
    yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        title: {
            text: 'y-axis title'
        }
    },
    legend: {
        enabled: true,
        backgroundColor: '#FCFFC5',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 3,
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            dataLabels: {
                enabled: true,
                format: '{point.y:.1f}'
            },
            zones: []
        }
    },
    tooltip: {
        // backgroundColor: '#FCFFC5',
        // borderColor: 'black',
        // borderRadius: 10,
        // borderWidth: 3,
        // crosshairs: [true, true],
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}%</b> of total<br/>'
    },

    series:[]
};
let chart_options4 = {
    chart: {
      type: null,
      // zoomType: 'xy'
      height: 300
    },
    title: {
        text: 'Loading...'
    },

    xAxis: {
        type: 'category',
        categories:["Jan","feb","mar","april","may","june","july","august","sept","oct","nov","dec"]
    },

    yAxis: {
        title: {
            text: null
        }
    },

    tooltip: {
        crosshairs: true,
        shared: true
    },

    plotOptions: {
      series: {
        fillOpacity: 0.1
      }
    },

    legend: {
    },

    series: []
};
let chart_options5={
    chart: {
        type: 'bar',
            zoomType: 'xy'
    },
    title: {
        text: 'Loading...'
    },
    subtitle: {
        text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
    },
    credits: {
        enabled: false
    },
    xAxis: {
        type: 'category',
            categories: null,
            title: {
            text: 'x-axis title'
        },
        labels: {
            style: {
                fontWeight: 'normal',
                    color: '#686464'
            }
        }
    },
    yAxis: {
        gridLineWidth: 0,
            minorGridLineWidth: 0,
                title: {
            text: 'y-axis title'
        }
    },
    legend: {
        enabled: true,
            backgroundColor: '#FCFFC5',
                borderColor: 'black',
                    borderRadius: 10,
                        borderWidth: 3,
                            title: {
            text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
                style: {
                fontWeight: 'normal'
            }
        }
    },
    plotOptions: {
        series: {
            borderWidth: 0,
                point: {
                events: {
                    click: function(e) {
                        // this.update({ pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>' }, true, false);
                        // this.tooltip.pointFormat = '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>'
                    }
                }
            },
            cursor: 'pointer',
                dataLabels: {
                enabled: true,
                    format: '{point.y:.1f}',
                        style: {
                    fontWeight: 'normal'
                }
            },
            zones: []
        }
    },
    tooltip: {
        // backgroundColor: '#FCFFC5',
        // borderColor: 'black',
        // borderRadius: 10,
        // borderWidth: 3,
        // crosshairs: [true, true],
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>'
    },
    series: [],
        drilldown: {
        activeAxisLabelStyle: {
            color: 'black',
                textDecoration: 'none',
                    fontWeight: 'normal'
        },
        activeDataLabelStyle: {
            color: 'black',
                textDecoration: 'none',
                    fontWeight: 'normal'
        },
        series: [
            {
                name: "Anambra",
                id: "Anambra",
                "data": [
                    [
                        "v65.0",
                        0.1
                    ],
                    [
                        "v64.0",
                        1.3
                    ],
                    [
                        "v63.0",
                        53.02
                    ],
                    [
                        "v62.0",
                        1.4
                    ],
                    [
                        "v61.0",
                        0.88
                    ],
                    [
                        "v60.0",
                        0.56
                    ],
                    [
                        "v59.0",
                        0.45
                    ],
                    [
                        "v58.0",
                        0.49
                    ],
                    [
                        "v57.0",
                        0.32
                    ],
                    [
                        "v56.0",
                        0.29
                    ],
                    [
                        "v55.0",
                        0.79
                    ],
                    [
                        "v54.0",
                        0.18
                    ],
                    [
                        "v51.0",
                        0.13
                    ],
                    [
                        "v49.0",
                        2.16
                    ],
                    [
                        "v48.0",
                        0.13
                    ],
                    [
                        "v47.0",
                        0.11
                    ],
                    [
                        "v43.0",
                        0.17
                    ],
                    [
                        "v29.0",
                        0.26
                    ]
                ]
            }
        ]
    }
};


export {chart_options, chart_options2, chart_options3, chart_options4, chart_options5};



// WEBPACK FOOTER //
// ./src/assets/js-on/highchart_options.js